import _ from "lodash";

import { AccountingPlanEntity } from "../../entity/AccountingPlanEntity";
import { HttpAdapter } from "../../main/adapters/HttpAdapter";

export class AccountingPlanHttpGateway {
    HttpAdapter = new HttpAdapter();
    baseUrl = `${publicSettings.aws.baseUrls.accounting}/accounting`;

    async createPlan({ user, plan }) {
        const response = await this.HttpAdapter.call(
            `${this.baseUrl}/plan/create`,
            {
                user,
                ...plan
            }
        );

        return response;
    }

    async getPlans() {
        const response = await this.HttpAdapter.call(
            `${this.baseUrl}/plan/get-all`
        );

        if (!response) return [];

        const plansList = [];

        for (const plan of response.response) {
            const planEntity = new AccountingPlanEntity(plan);
            planEntity.formatDate();
            planEntity.formatStatus();
            planEntity.setTooltipDisabled();
            planEntity.setUpdateAtFilter();

            plansList.push(planEntity);
        }
        return plansList;
    }

    async getNamesPlans(options = {}) {
        const result = await this.HttpAdapter.call(
            `${this.baseUrl}/plan/get-all`
        );
        if (!result) return [];
        if (options.onlyVisibles) {
            const plans = result.response.filter(
                (plan) => plan.visible || plan.name === options.currentPlan
            );
            return plans.map((plan) => plan.name);
        }
        return result.response.map((plan) => plan.name);
    }

    async updateById({ user, plan }) {
        const response = await this.HttpAdapter.call(
            `${this.baseUrl}/plan/update-by-id`,
            {
                user,
                ...plan
            }
        );

        return response;
    }

    async removePlanById(planId, user) {
        const response = await this.HttpAdapter.call(
            `${this.baseUrl}/plan/remove-by-id`,
            {
                _id: planId,
                user
            }
        );
        return response;
    }

    async getPlanByName(planName) {
        if (!planName) return new AccountingPlanEntity({});

        const response = await this.HttpAdapter.call(
            `${this.baseUrl}/plan/get-by-name`,
            {
                name: planName
            }
        );

        if (!_.get(response, "response"))
            return new AccountingPlanEntity({ modules: [], features: [] });

        return new AccountingPlanEntity(response.response);
    }

    async getById(_id) {
        if (!_id) return false;

        const response = await this.HttpAdapter.call(
            `${this.baseUrl}/plan/get-by-id`,
            {
                _id
            }
        );

        return _.get(response, "response");
    }
}
